import { useEffect, useRef, useState } from "react";

// Silent autoplay preview over the card thumbnail; shown only once YouTube reports playback, hidden on embed errors.
export const HoverPreview = ({ src, videoId }) => {
  const [playing, setPlaying] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onMsg = (e) => {
      if (!/youtube/.test(e.origin) || e.source !== ref.current?.contentWindow) return;
      let d;
      try {
        d = typeof e.data === "string" ? JSON.parse(e.data) : e.data;
      } catch {
        return;
      }
      if (d?.event === "onError") setPlaying(false);
      const state = d?.event === "onStateChange" ? d.info : d?.info?.playerState;
      if (state === 1) setPlaying(true);
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, []);

  const listen = () => ref.current?.contentWindow?.postMessage(JSON.stringify({ event: "listening", id: videoId }), "*");

  return (
    <div
      data-testid={`hover-preview-${videoId}`}
      data-playing={playing ? "1" : "0"}
      className={`pointer-events-none absolute inset-0 z-[5] overflow-hidden bg-black transition-opacity duration-500 ${playing ? "opacity-100" : "opacity-0"}`}
    >
      <iframe
        ref={ref}
        src={src}
        title="Preview"
        tabIndex={-1}
        allow="autoplay; encrypted-media"
        onLoad={listen}
        className="absolute left-1/2 top-1/2 h-[135%] w-[135%] -translate-x-1/2 -translate-y-1/2 border-0"
      />
    </div>
  );
};
